<template>
  <div class="blog-else">
    <reef class="reef--reverse"></reef>
  </div>
</template>
<script>
  import Reef from '../components/Reef.vue'
  export default {
    components: {
      Reef
    }
    
  }
</script>